"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 訓練実施報告登録：訓練目的達成度評価、対策本部長コメント
 */
function EvaluationField(props) {
  var _errors$kunrenEvaluat, _errors$hqComments;
  const {
    intl,
    reportEntry,
    setEntry,
    errors
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      lg: 3,
      xs: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.BCM_KUNREN_EVALUATION
    })
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: reportEntry.kunrenEvaluation,
    onChange: setEntry('kunrenEvaluation'),
    maxLength: 1000,
    multiline: true,
    rows: 3,
    error: !!errors.kunrenEvaluation,
    helperText: (_errors$kunrenEvaluat = errors.kunrenEvaluation) === null || _errors$kunrenEvaluat === void 0 ? void 0 : _errors$kunrenEvaluat.message
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      lg: 3,
      xs: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.BCM_KUNREN_EVALUATION_COMMENT
    })
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: reportEntry.hqComments,
    onChange: setEntry('hqComments'),
    maxLength: 1000,
    multiline: true,
    rows: 3,
    error: !!errors.hqComments,
    helperText: (_errors$hqComments = errors.hqComments) === null || _errors$hqComments === void 0 ? void 0 : _errors$hqComments.message
  }))));
}
var _default = exports.default = (0, _reactIntl.injectIntl)(EvaluationField);